import { testimonials } from '@/mocks/testimonials';

export default function TestimonialsSection() {
  return (
    <section className="bg-offwhite py-20 md:py-28">
      <div className="max-w-7xl mx-auto px-4 md:px-8">
        {/* Header */}
        <div className="text-center mb-14">
          <span className="font-sans text-xs tracking-widest uppercase text-rose font-semibold">
            Kund*innenstimmen
          </span>
          <h2 className="font-serif text-4xl md:text-5xl font-medium text-charcoal mt-3 mb-4">
            Was unsere Kund*innen sagen
          </h2>
          <p className="font-sans text-base text-charcoal/60 max-w-md mx-auto leading-relaxed">
            Echte Erfahrungen von echten Kund*innen aus Köln.
          </p>
        </div>

        {/* Cards */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
          {testimonials.map((t) => (
            <article
              key={t.id}
              className="bg-white rounded-2xl p-7 flex flex-col gap-5 ring-1 ring-blush hover:-translate-y-1 transition-transform duration-300"
            >
              {/* Stars */}
              <div className="flex gap-1">
                {Array.from({ length: t.stars }).map((_, i) => (
                  <span key={i} className="w-4 h-4 flex items-center justify-center">
                    <i className="ri-star-fill text-rose text-sm" />
                  </span>
                ))}
              </div>

              {/* Quote */}
              <p className="font-sans text-sm text-charcoal/75 leading-[1.8] flex-1 italic">
                {t.text}
              </p>

              {/* Author */}
              <div className="flex items-center justify-between pt-4 border-t border-blush">
                <div className="flex items-center gap-3">
                  <div className="w-9 h-9 flex items-center justify-center bg-rose/15 rounded-full">
                    <i className="ri-user-smile-line text-rose text-base" />
                  </div>
                  <div>
                    <p className="font-sans text-sm font-semibold text-charcoal leading-none mb-0.5">{t.name}</p>
                    <p className="font-sans text-xs text-charcoal/50">{t.treatment}</p>
                  </div>
                </div>
                <span className="font-sans text-xs text-charcoal/40">{t.date}</span>
              </div>
            </article>
          ))}
        </div>

        {/* Google Rating hint */}
        <div className="flex flex-col sm:flex-row items-center justify-center gap-3 mt-10">
          <div className="flex gap-1">
            {Array.from({ length: 5 }).map((_, i) => (
              <span key={i} className="w-4 h-4 flex items-center justify-center">
                <i className="ri-star-fill text-rose text-sm" />
              </span>
            ))}
          </div>
          <p className="font-sans text-sm text-charcoal/60">
            <strong className="text-charcoal">5,0 / 5</strong> Bewertung · Google Reviews
          </p>
        </div>
      </div>
    </section>
  );
}
